import { FC } from "react";
// 组件
import { Table } from 'antd';
import ChildrenTableCell from "../childrenTableCell";
// 方法
import useColumnsHook from "../../hook/useColumnsHook";
// 常量
import { EditSubTableProps } from "../../interface";

/** 子表 */
const EditSubTable: FC<EditSubTableProps> = props => {
  const { childrenColumns, dataSource, mainKey, } = props;
  const { columns } = useColumnsHook({ props: { mainColumns: childrenColumns, }, isChildren: true, });
  
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      size="small"
      components={{
        body: {
          cell: ChildrenTableCell,
        },
      }}
    />
  );
};

export default EditSubTable;
